import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ReportsGateway } from './reports.gateway'
import { EnrollmentCountModel } from '../models/enrollment-count.model'
import { MyClientsCriteria } from '../models/my-clients-criteria'
import { EnrollmentReportSummaryModel } from '../models/enrollment-report-summary.model'
import { LeadType } from '../models/lead-type-model'
import { ListStatus } from '../models/list-status-model'
import { OnList } from '../models/enrollment-search-on'
import { EnrollmentSearch } from '../models/EnrollmentSearch'
import { SearchModel } from '../models/enrollment-search-details'
import { ReportsEnrollmentSearch } from '../models/reports-enrollment-search-status-model'
import { GetEnrollmentRequest } from '../models/GetEnrollmentDataRequest'
import { GetEnrollmentDataResponse } from '../models/get-enrollment-data-response'
import { EnrollmentReportDetailsModel } from '../models/enrollment-report-details.model'
import { MedicareIDSearch } from '../models/MedicareIDSearch'
import { ExternalTrainingReport } from '../models/external-training-report'
import { ExternlaTrainingSearchCriteria } from '../models/external-training-search-criteria'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { UsersInactiveModel } from '../models/users-inactive.model'
import { UserProfileChangeModel } from '../models/UserProfile.model'
import { UserProfile } from '../models/user-profile'

@Injectable()
export class NetworkReportsGateway extends ReportsGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getEnrollmentsCount(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]> {
        return this.http.post<EnrollmentCountModel[]>('../api/getEnrollmentCounts', JSON.stringify(myClientsCriteria))
    }

    getPWEnrollmentsCount(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]> {
        return this.http.post<EnrollmentCountModel[]>('../api/getPWEnrollmentCounts', JSON.stringify(myClientsCriteria))
    }

    getEnrollmentsCountAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]> {
        return this.http.post<EnrollmentCountModel[]>('../api/getEnrollmentCountsAU', JSON.stringify(myClientsCriteria))
    }

    getPWEnrollmentsCountAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]> {
        return this.http.post<EnrollmentCountModel[]>('../api/getPWEnrollmentCountsAU', JSON.stringify(myClientsCriteria))
    }

    getEnrollmentReportSummary(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]> {
        return this.http.post<EnrollmentReportSummaryModel[]>('../api/getEnrollmentReportSummary', JSON.stringify(myClientsCriteria))
    }

    getPWEnrollmentReportSummary(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]> {
        return this.http.post<EnrollmentReportSummaryModel[]>('../api/getPWEnrollmentReportSummary', JSON.stringify(myClientsCriteria))
    }

    getEnrollmentReportSummaryAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]> {
        return this.http.post<EnrollmentReportSummaryModel[]>('../api/getEnrollmentReportSummaryAU', JSON.stringify(myClientsCriteria))
    }

    getPWEnrollmentReportSummaryAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]> {
        return this.http.post<EnrollmentReportSummaryModel[]>('../api/getPWEnrollmentReportSummaryAU', JSON.stringify(myClientsCriteria))
    }

    getAlternativeReportingEnabled(userProfileId: number): Observable<boolean> {
        return this.http.get<boolean>('../api/isMyClientsEnabledForAlternateUsers/' + userProfileId.toString())
    }

    getEnrollmentReportDetails(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportDetailsModel> {
        return this.http.post<EnrollmentReportDetailsModel>('../api/getEnrollmentReportDetails', JSON.stringify(myClientsCriteria))
    }
    getEnrollmentReportSummarySync(myClientsCriteria: MyClientsCriteria): EnrollmentReportSummaryModel[] {
        var data = JSON.stringify(myClientsCriteria)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getEnrollmentReportSummary', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getConsumerSearchListSync(searchModel: SearchModel): EnrollmentSearch[] {
        var data = JSON.stringify(searchModel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getConsumerSearchList', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getCustomSearchListSync(searchModel: SearchModel): EnrollmentSearch[] {
        var data = JSON.stringify(searchModel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getCustomSearchList', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getIpadSearchListSync(searchModel: SearchModel): EnrollmentSearch[] {
        var data = JSON.stringify(searchModel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getIpadSearchList', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getLeadTypes(): Observable<Array<LeadType>> {
        return this.http.get<Array<LeadType>>('../api/getLeadTypes')
    }
    getStatusList(): Observable<Array<ListStatus>> {
        return this.http.get<Array<ListStatus>>('../api/getStatusList')
    }

    getSearchFilterList(): Observable<Array<OnList>> {
        return this.http.get<Array<OnList>>('../api/getSearchFilterList')
    }

    //getCustomSearchList(ListValueId: number, Status: number, LeadTypeID: string, StartDate: string, EndDate: string): Observable<Array<EnrollmentSearch>> {
    //    return this.http.get<Array<EnrollmentSearch>>('../api/getCustomSearchList/' + ListValueId + '/' + Status + '/' + LeadTypeID + '/' + StartDate + '/' + EndDate )
    //}
    getCustomSearchList(FmoModel: SearchModel): Observable<Array<EnrollmentSearch>> {
        return this.http.post<Array<EnrollmentSearch>>('../api/getCustomSearchList', JSON.stringify(FmoModel))
    }

    updateEnrollmentStatus(FmoModel: EnrollmentSearch): Observable<Array<EnrollmentSearch>> {
        return this.http.post<Array<EnrollmentSearch>>('../api/enrollment/updateEnrollmentStatus', JSON.stringify(FmoModel))
    }

    getEnrollmentAppDetails(getEnrollmentRequest: GetEnrollmentRequest): Observable<GetEnrollmentDataResponse[]> {
        return this.http.post<GetEnrollmentDataResponse[]>('../api/enrollment/GetEnrollmentData', JSON.stringify(getEnrollmentRequest))
    }

    getIpadSearchList(FmoModel: SearchModel): Observable<Array<EnrollmentSearch>> {
        return this.http.post<Array<EnrollmentSearch>>('../api/getIpadSearchList', JSON.stringify(FmoModel))
    }

    getConsumerSearchList(FmoModel: SearchModel): Observable<Array<EnrollmentSearch>> {
        return this.http.post<Array<EnrollmentSearch>>('../api/getConsumerSearchList', JSON.stringify(FmoModel))
    }

    getMedicareSearchData(searchText: string): Observable<MedicareIDSearch[]> {
        return this.http.get<Array<MedicareIDSearch>>('../api/getMedicareSearchData/' + searchText)
    }

    getMedicareSearchDataExport(searchText: string): Observable<MedicareIDSearch[]> {
        return this.http.get<Array<MedicareIDSearch>>('../api/getMedicareSearchDataExport/' + searchText)
    }

    getWESLastAccess(): Observable<string> {
        return this.http.get<string>('../api/getWESLastAccess')
    }

    getExternalTrainingReport(searchCriteria: ExternlaTrainingSearchCriteria): Observable<ExternalTrainingReport[]> {
        return this.http.post<Array<ExternalTrainingReport>>('../api/getExternalTrainingReport', JSON.stringify(searchCriteria))
    }
    getCarrierList(orgID: number, state: string): Observable<ValidatedSelectOptionModel[]> {
        let getUrl = '../api/getCarrierList/' + orgID + '/' + state
        return this.http.get<ValidatedSelectOptionModel[]>(getUrl)
    }
    getCUIDList(orgID: number, state: string, carrierId: string): Observable<ValidatedSelectOptionModel[]> {
        let getUrl = '../api/getCUIDList/' + orgID + '/' + state + '/' + carrierId
        return this.http.get<ValidatedSelectOptionModel[]>(getUrl)
    }
    getPlanTypeList(orgID: number, state: string, carrierId: string, cuid: string): Observable<ValidatedSelectOptionModel[]> {
        let getUrl = '../api/getPlanTypeList/' + orgID + '/' + state + '/' + carrierId + '/' + cuid
        return this.http.get<ValidatedSelectOptionModel[]>(getUrl)
    }
    getAgentList(orgID: number, state: string, carrierId: string, cuid: string): Observable<ValidatedSelectOptionModel[]> {
        let getUrl = '../api/getAgentList/' + orgID + '/' + state + '/' + carrierId + '/' + cuid
        return this.http.get<ValidatedSelectOptionModel[]>(getUrl)
    }

    getInactiveUsersSync(searchmodel: SearchModel): UsersInactiveModel[] {
        var data = JSON.stringify(searchmodel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getInactiveUsers', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
        // return this.http.post<Array<UsersInactiveModel>>('../api/getInactiveUsers', JSON.stringify(searchmodel))
    }
    getInactiveUsers(searchmodel: SearchModel): Observable<Array<UsersInactiveModel>> {
        return this.http.post<Array<UsersInactiveModel>>('../api/getInactiveUsers', JSON.stringify(searchmodel))
    }

    getUserProfileChange(searchmodel: SearchModel): Observable<Array<UserProfileChangeModel>> {
        return this.http.post<Array<UserProfileChangeModel>>('../api/getUserProfileChange', JSON.stringify(searchmodel))
    }

    getUserProfileChangeSync(searchmodel: SearchModel): UserProfileChangeModel[] {
        var data = JSON.stringify(searchmodel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getUserProfileChange', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
        // return this.http.post<Array<UsersInactiveModel>>('../api/getInactiveUsers', JSON.stringify(searchmodel))
    }

    getNewUsersAddedSync(searchmodel: SearchModel): UsersInactiveModel[] {
        var data = JSON.stringify(searchmodel)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getNewUsersAdded', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
        // return this.http.post<Array<UsersInactiveModel>>('../api/getInactiveUsers', JSON.stringify(searchmodel))
    }
    getNewUsersAdded(searchmodel: SearchModel): Observable<Array<UsersInactiveModel>> {
        return this.http.post<Array<UsersInactiveModel>>('../api/getNewUsersAdded', JSON.stringify(searchmodel))
    }

    getAlternateUserProfiles(userProfileId: number): Observable<Array<UserProfile>> {
        return this.http.get<Array<UserProfile>>('../api/getAlternateUserProfiles/' + userProfileId)
    }
}
